import { ADMIN_LOTS } from '../constants/adminNavLabels';

export function lotDetailPath(batchId: string): string {
  return `${ADMIN_LOTS.path}/${encodeURIComponent(batchId)}`;
}

export function productLotsHref(productId: string, batchId?: string): string {
  const base = `/catalog/products/${encodeURIComponent(productId)}?tab=lots`;
  if (!batchId) return base;
  return `${base}&highlightBatch=${encodeURIComponent(batchId)}`;
}
